import EarningsReportRenderer from '@app/components/EarningsReportRenderer'
import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import {
  actionCreators,
  IProjectedEarningsState,
} from '../modules/projectedEarnings'

type ComponentProps = IProjectedEarningsState & typeof actionCreators

export default class ProjectedProfitListPage extends React.PureComponent<
  ComponentProps
> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public componentWillMount() {
    this.props.loadProjectedEarnings(0, 20, false, undefined)
  }

  public render() {
    return (
      <DocumentTitle title='Admin - Earnings Summary'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Projected Earnings Summary</h3>
          </div>
          <div className='mt-4'>
            <EarningsReportRenderer reportData={this.props.items} />
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No projected earnings</div>
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
